import CodeGen from "../components/code-gen";
import PageLayout from "../components/common/page-layout";
import { RequireAuth } from "../hooks/use-auth";

/** Route page for the backend boilerplate generator. */
const CodeGenPage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Code gen">
        <CodeGen />
      </PageLayout>
    </RequireAuth>
  );
};

export default CodeGenPage;
